import "./faq.css";
import FaqQuestion from "../components/faq-question";
import GenericSeo from "../components/seo/generic-seo";
import { WithContext, FAQPage } from "schema-dts";

export default function FAQ() {
	const faqJsonLd: WithContext<FAQPage> = {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: [
			{
				"@type": "Question",
				name: "What is a lamb share?",
				acceptedAnswer: {
					"@type": "Answer",
					text: "A lamb share is a way for you to purchase a portion of a locally raised lamb directly from our farm. You can choose to buy a whole lamb or a half share. Once the animal is processed by a professional butcher, you’ll pick up your packaged meat directly from the butcher’s shop.",
				},
			},
			{
				"@type": "Question",
				name: "How do I order a lamb share?",
				acceptedAnswer: {
					"@type": "Answer",
					text: "To reserve a lamb share, you’ll place a non-refundable deposit with us. This deposit secures your portion of a lamb until harvest time. Once the lamb is ready, we’ll coordinate processing with the butcher, and you’ll pay the remaining balance before pickup.",
				},
			},
			{
				"@type": "Question",
				name: "How much meat do I get with a whole or half lamb?",
				acceptedAnswer: {
					"@type": "Answer",
					text: "A whole lamb typically yields about 45 pounds of cut, trimmed, and packaged meat. A half lamb is about 22–23 pounds. Actual weights may vary depending on the size of the animal and your chosen cuts.",
				},
			},
			{
				"@type": "Question",
				name: "How old are the lambs?",
				acceptedAnswer: {
					"@type": "Answer",
					text: "Our lambs are born in early spring and are typically butchered in the fall, making them about 6 to 8 months old at harvest. This age ensures tender, flavorful meat.",
				},
			},
			{
				"@type": "Question",
				name: "Can I buy a live sheep?",
				acceptedAnswer: {
					"@type": "Answer",
					text: "Yes! Live sheep are available, and prices vary based on age.",
				},
			},
			{
				"@type": "Question",
				name: "How do I pay for my lamb?",
				acceptedAnswer: {
					"@type": "Answer",
					text: "Once you reserve a lamb share, you’ll submit a deposit ($50/half or $100/whole). The balance is due before pickup. Meat is priced at $6.00/lb hanging weight, plus processing fees which are paid directly to the butcher.",
				},
			},
		],
	};
	return (
		<div className="faq-container">
			<GenericSeo
				title="FAQ | Heron Lane Farm"
				description="Find answers to common questions about ordering pasture-raised lamb from Heron Lane Farm in Whatcom County, WA."
				ogDescription="Answers about lamb shares, ordering, payments, and more from Heron Lane Farm."
				canonicalUrlPath="/faq"
				jsonLd={faqJsonLd}
			/>
			<div className="faq-header">Frequently Asked Questions</div>
			<div className="faq-content">
				<FaqQuestion
					question="What is a lamb share?"
					answer="A lamb share is a way for you to purchase a portion of a locally raised lamb directly from our farm. You can choose to buy a whole lamb or a half share. Once the animal is processed by a professional butcher, you’ll pick up your packaged meat directly from the butcher’s shop. It’s a great way to stock your freezer with high-quality, pasture-raised lamb while supporting local agriculture."
				/>
				<FaqQuestion
					question="How do I order a lamb share?"
					answer="To reserve a lamb share, you’ll place a non-refundable deposit with us. This deposit secures your portion of a lamb until harvest time. Once the lamb is ready, we’ll coordinate processing with the butcher, and you’ll pay the remaining balance before pickup. Reserving early ensures availability, as shares are limited each season."
				/>
				<FaqQuestion
					question="How much meat do I get with a whole or half lamb?"
					answer="A whole lamb typically yields about 45 pounds of cut, trimmed, and packaged meat. If you reserve a half lamb, you can expect approximately 22–23 pounds of meat. Actual weights may vary slightly depending on the size of the animal and your chosen cuts."
				/>
				<FaqQuestion
					question="How old are the lambs?"
					answer="Our lambs are born in early spring and are typically butchered in the fall, making them about 6 to 8 months old at the time of harvest. This age range ensures tender, flavorful meat."
				/>
				<FaqQuestion
					question="Can I buy a live sheep?"
					answer="Yes! Prices vary based on age."
				/>
				<FaqQuestion
					question="How do I pay for my lamb?"
					answer="Once you reserve a lamb share, you’ll submit a deposit ($50/half or $100/whole). The balance is due before pickup. Meat is priced at $6.00/lb hanging weight, plus processing fees which are paid directly to the butcher."
				/>
			</div>
		</div>
	);
}
